import React from 'react';
import Glyph from './Glyph';
import * as sizes from './index';

export default class SurveyIcon extends React.PureComponent {
  static defaultProps = {
    style: {},
    height: 14,
    width: 14,
  };

  render() {
    const canvasSize = sizes.getCanvasSize(this.props);
    return (
      <svg
        className={this.props.className}
        onClick={this.props.onClick}
        width={this.props.width}
        height={this.props.height}
        style={{
          color: this.props.color,
          verticalAlign: '-10%',
          ...this.props.style,
        }}
        viewBox={`0 0 ${canvasSize} ${canvasSize}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <Glyph
          canvasSize={canvasSize}
          height={this.props.radius || this.props.height}
          width={this.props.radius || this.props.width}
          icon={this.props.icon}
        />
      </svg>
    );
  }
}
